<template>
    <div id="titles" class="">
    </div>
</template>

<script>
export default {
  name: "MercureRatesHorizontalV1Titles"
};
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../_tribe.scss";

#titles {
  width: 100%;
  background-color: $purple;
  @include heightPercent(80);
  text-align: left;
  text-transform: uppercase;
}
</style>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/tribe/rates/horizontal/v1/titles.vue